/*******************************************************************************

	Project: DebrunnerAcifer
	Author:  What.Digital
	Date:    03.2021

********************************************************************************

TOC:
	Alert
	Scroll to top
	Contact Form 7 Fix
	Mobile Language Switcher

*******************************************************************************/

jQuery(document).ready(function ($) {
  /* Alert
	------------------------------------------------------------------------------*/

  $(".js-cookie-alert").each(function () {
    var componentEl = $(this);
    var closeEl = componentEl.find(".js-cookie-alert__close");
    var cookieName = componentEl.attr("id");

    if (undefined === $.cookie(cookieName)) {
      componentEl.removeClass("hidden");

      closeEl.on("click", function (event) {
        event.preventDefault();

        componentEl.fadeOut(400, function () {
          componentEl.addClass("hidden");

          $.cookie(cookieName, true, { expires: 365, path: "/" });
        });
      });
    }
  });

  /* Scroll to top
	------------------------------------------------------------------------------*/

  $(document).on("scroll", function () {
    if ($(window).scrollTop() > 200) {
      $(".c-scroll-to-top").addClass("show");
    } else {
      $(".c-scroll-to-top").removeClass("show");
    }
  });

  $(".c-scroll-to-top").on("click", function (event) {
    event.preventDefault();
    var verticalOffset =
      typeof verticalOffset != "undefined" ? verticalOffset : 0;
    var element = $("body");
    var offset = element.offset();
    var offsetTop = offset.top;
    $("html, body").animate({ scrollTop: offsetTop }, 500, "linear");
  });

  /* Contact Form 7 Fix
	/*******************************************************************************/

  $(".wpcf7-form p:empty").remove();

  /* Mobile Language Switcher
	------------------------------------------------------------------------------*/

  $(".js-language-switcher").on("change", function (event) {
    event.preventDefault();

    window.location.href = $(this).val();
  });

  /* Set the correct order number for the ordered lists
	------------------------------------------------------------------------------*/
  $("ol[start]").each(function () {
    let element = $(this);

    element.css("counter-reset", "item " + (element.attr("start") - 1));
  });

  /* Modal for newsletter
	------------------------------------------------------------------------------*/
  $(".c-btn-open-modal").on("click", function () {
    $(".newsletter-modal").fadeIn();
  });

  $(document).on("click", function (event) {
    console.log($(event.target));
    if ($(event.target).hasClass("close-button")) {
      $(".newsletter-modal").fadeOut();
    } else if ($(event.target).hasClass("close-modal")) {
      $(".newsletter-modal").fadeOut();
    } else if (
      !$(event.target).closest(".footer-newsletter").length &&
      !$(event.target).closest(".c-btn-open-modal").length
    ) {
      $(".newsletter-modal").fadeOut();
    }
  });

});
